import React from 'react';

import {Provider as ReduxProvider} from 'react-redux';

import {getStore} from '../store';

const withRedux =
    <P extends {}>(Component: React.FC<P>) =>
    (props: P) => (
        <ReduxProvider store={getStore()}>
            <Component {...props} />
        </ReduxProvider>
    );

export {withRedux};
